<div class="phone-number-field" fxFlex="grow" id="PhoneNumber">
  <lib-phone-input
    [formControl]="formGroup.controls.phoneNumber"
    [label]="label || 'Phone Number'"
    [required]="required"
  ></lib-phone-input>
  <div
    class="mat-mdc-form-field-error phone-number-error"
    [id]="errorId"
    role="alert"
  >
    @if (
      formGroup.controls.phoneNumber.hasError('minlength') ||
      formGroup.controls.phoneNumber.hasError('notEmpty')
    ) {
      Enter phone number in format (###) ###-####
    }
  </div>
</div>
<mat-form-field
  appearance="outline"
  floatLabel="always"
  subscriptSizing="dynamic"
  class="phone-extension"
>
  <mat-label [ngClass]="displayLabel()">Ext</mat-label>
  <input
    matInput
    forbidAngleBrackets
    [formControl]="formGroup.controls.extension"
    placeholder="Ext"
    aria-label="Telephone number extension"
  />
</mat-form-field>
